/* OVATIME · The Golden One PDP V13 */
(() => {
  'use strict';

  const SELECTOR = '[data-tgo-carousel]';
  const WHY_IMAGE = 'https://cdn.shopify.com/s/files/1/0705/3623/3226/files/Produkt-Warum_c1527126-3994-4f60-ac23-e59317c2829b.png?v=1785250700';
  const PLAN_IMAGE_12 = 'https://cdn.shopify.com/s/files/1/0705/3623/3226/files/Produkt-3.png?v=1785250028';
  const PLAN_IMAGE_SINGLE = 'https://cdn.shopify.com/s/files/1/0705/3623/3226/files/Produkt-1.png?v=1785250028';
  const HERO_VIDEO_IMAGE = 'https://cdn.shopify.com/s/files/1/0705/3623/3226/files/Cebio_trinkt_The_Golden_One.webp?v=1783497119&width=900';

  const icons = {
    sparkle: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 8c1.2 8.7 5.3 12.8 14 14-8.7 1.2-12.8 5.3-14 14-1.2-8.7-5.3-12.8-14-14 8.7-1.2 12.8-5.3 14-14Z"/></svg>',
    routine: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M10 18a16 16 0 0 1 27-5l3 3m0 0v-8m0 8h-8M38 30a16 16 0 0 1-27 5l-3-3m0 0v8m0-8h8"/></svg>',
    energy: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M28 5 13 27h11l-4 16 15-23H24l4-15Z"/></svg>',
    shield: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 5c6 5 12 7 18 8v10c0 11-7 17-18 21C13 40 6 34 6 23V13c6-1 12-3 18-8Z"/><path d="m16 24 6 6 11-12"/></svg>',
    muscle: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M16 38c-5-3-7-8-5-13 1-4 4-6 8-7l2-8 5 1-1 8 4 3c3-2 7-1 10 2 4 5 2 12-3 15-5 3-14 3-20-1Z"/><path d="M20 20c2 3 5 4 9 3"/></svg>',
    check: '<svg viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="18"/><path d="m15 24 6 6 12-13"/></svg>',
    truck: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M5 12h24v23H5zM29 21h8l6 8v6H29z"/><circle cx="14" cy="37" r="4"/><circle cx="36" cy="37" r="4"/></svg>',
    pause: '<svg viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="18"/><path d="M19 17v14M29 17v14"/></svg>'
  };

  function scrollAmount(track) {
    const first = track.querySelector(':scope > *');
    if (!first) return Math.max(280, track.clientWidth * 0.82);
    const style = window.getComputedStyle(track);
    const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function initialiseCarousel(root) {
    if (!root || root.dataset.tgoInitialized === 'true') return;
    const track = root.querySelector('[data-tgo-track]');
    if (!track) return;
    root.dataset.tgoInitialized = 'true';
    track.setAttribute('tabindex', track.getAttribute('tabindex') || '0');
    const previous = root.querySelector('[data-tgo-prev]');
    const next = root.querySelector('[data-tgo-next]');
    const progress = root.querySelector('[data-tgo-progress]');
    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    let updateFrame = 0;

    const updateState = () => {
      updateFrame = 0;
      const maximum = maxScroll();
      const isScrollable = maximum > 2;
      const atStart = !isScrollable || track.scrollLeft <= 2;
      const atEnd = !isScrollable || track.scrollLeft >= maximum - 2;
      root.classList.toggle('is-scrollable', isScrollable);

      if (previous) {
        previous.disabled = atStart;
        previous.setAttribute('aria-disabled', String(atStart));
      }
      if (next) {
        next.disabled = atEnd;
        next.setAttribute('aria-disabled', String(atEnd));
      }

      if (progress) {
        const visible = track.scrollWidth > 0
          ? Math.min(100, (track.clientWidth / track.scrollWidth) * 100)
          : 100;
        const left = maximum > 0
          ? (track.scrollLeft / maximum) * Math.max(0, 100 - visible)
          : 0;
        progress.style.width = `${visible}%`;
        progress.style.left = `${left}%`;
      }
    };

    const queueStateUpdate = () => {
      if (updateFrame) return;
      updateFrame = window.requestAnimationFrame(updateState);
    };

    const move = (direction) => {
      const maximum = maxScroll();
      if (maximum <= 2) {
        updateState();
        return;
      }
      const target = Math.min(
        maximum,
        Math.max(0, track.scrollLeft + (direction * scrollAmount(track)))
      );
      track.scrollTo({ left: target, behavior: 'smooth' });
      window.setTimeout(updateState, 420);
    };

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
    });
    track.addEventListener('scroll', queueStateUpdate, { passive: true });
    track.querySelectorAll('img').forEach((image) => {
      if (!image.complete) image.addEventListener('load', updateState, { once: true });
    });
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateState);
      observer.observe(track);
    } else {
      window.addEventListener('resize', queueStateUpdate, { passive: true });
    }
    window.requestAnimationFrame(updateState);
  }

  function setImage(img, src, alt) {
    if (!img || !src) return;
    img.src = src;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.alt = alt || '';
  }

  function orderEditorialSections() {
    const why = document.querySelector('.tgo13-why');
    const athletes = document.querySelector('.tgo13-athletes');
    const quality = document.querySelector('.tgo13-quality');
    if (!why || !quality) return;
    const whySection = why.closest('.shopify-section') || why;
    const athletesSection = athletes?.closest('.shopify-section') || athletes;
    const qualitySection = quality.closest('.shopify-section') || quality;
    const parent = qualitySection.parentNode;
    if (!parent) return;

    if (whySection === qualitySection) {
      quality.parentNode?.insertBefore(why, quality);
      if (athletes && athletes !== quality) quality.parentNode?.insertBefore(athletes, quality);
      return;
    }

    if (whySection.nextElementSibling !== athletesSection && athletesSection) {
      parent.insertBefore(whySection, qualitySection);
      parent.insertBefore(athletesSection, qualitySection);
    } else if (whySection.nextElementSibling !== qualitySection && !athletesSection) {
      parent.insertBefore(whySection, qualitySection);
    }
  }

  function updatePlanVisuals() {
    const hero = document.querySelector('.golden-smartrr.tgo13-hero');
    if (!hero) return false;
    const planImage12 = hero.dataset.planImage12 || PLAN_IMAGE_12;
    const planImage4 = hero.dataset.planImage4 || PLAN_IMAGE_SINGLE;
    const planImageOnetime = hero.dataset.planImageOnetime || PLAN_IMAGE_SINGLE;
    const twelveWeek = hero.querySelector('.golden-smartrr__benefits-box');
    const fourWeek = hero.querySelector('.golden-smartrr__options .golden-smartrr__option[data-option="subscription"]');
    const oneTime = hero.querySelector('.golden-smartrr__option[data-option="onetime"]');
    twelveWeek?.classList.add('tgo13-routine-plan', 'tgo13-routine-plan--12');
    fourWeek?.classList.add('tgo13-routine-plan', 'tgo13-routine-plan--4');
    oneTime?.classList.add('tgo13-plan--onetime');
    setImage(twelveWeek?.querySelector('.tgo13-plan-product img'), planImage12, '12-Wochen-Routine');
    setImage(fourWeek?.querySelector('.tgo13-plan-product img'), planImage4, '4-Wochen-Routine');
    setImage(oneTime?.querySelector('.tgo13-plan-product img'), planImageOnetime, 'The Golden One Einmalkauf');

    const setQuantityBadge = (card, quantity) => {
      const productVisual = card?.querySelector('.tgo13-plan-product');
      if (!productVisual) return false;
      let badge = productVisual.querySelector('.tgo13-plan-product__qty');
      if (!badge) {
        badge = document.createElement('b');
        badge.className = 'tgo13-plan-product__qty';
        productVisual.appendChild(badge);
      }
      const label = String(quantity);
      if (badge.textContent !== label) badge.textContent = label;
      return true;
    };

    const twelveReady = setQuantityBadge(twelveWeek, 3);
    const fourReady = setQuantityBadge(fourWeek, 1);
    return twelveReady && fourReady;
  }

  /*
   * The purchase-card artwork is enhanced by the section's own script. On a
   * cold Shopify render that markup may arrive after this shared asset, so a
   * short-lived observer applies images and quantity badges when it is ready.
   */
  function observePlanVisuals() {
    const hero = document.querySelector('.golden-smartrr.tgo13-hero');
    if (!hero || hero.dataset.tgoPlanVisualsObserved === 'true') return;
    hero.dataset.tgoPlanVisualsObserved = 'true';
    if (updatePlanVisuals()) return;

    const observer = new MutationObserver(() => {
      if (updatePlanVisuals()) observer.disconnect();
    });
    observer.observe(hero, { childList: true, subtree: true });
  }

  function tgoAssetUrl(filename) {
    const script = [...document.scripts].find((item) => item.src.includes('tgo-pdp-v13.js'));
    return script ? new URL(filename, script.src).href : filename;
  }

  /*
   * Keeps the reference module in one deterministic location: directly below
   * the three purchase reassurance items. The reconstruction also upgrades
   * older Liquid/fallback markup without duplicating the component.
   */
  function mountHeroCommerceFallback() {
    const hero = document.querySelector('.golden-smartrr.tgo13-hero');
    if (!hero) return;

    const existing = hero.querySelector('[data-tgo-hero-commerce]');
    const purchaseProof = hero.querySelector('[data-tgo-purchase-proof]') ||
      existing?.querySelector('.tgo-hero-proof');
    const showPurchaseProof = hero.dataset.showPurchaseProof !== 'false';
    const benefitContent = existing
      ? [...existing.querySelectorAll('.tgo-hero-benefit')].slice(0, 3).map((item) => ({
          title: item.querySelector('strong')?.textContent.trim() || '',
          text: item.querySelector('.tgo-hero-benefit__copy span')?.textContent.trim() || ''
        }))
      : [];
    const defaults = [
      { title: 'Mehr Energie', text: 'Leichter durch den Tag' },
      { title: 'Starkes Immunsystem', text: 'Mehr Konstanz' },
      { title: 'Schnellere Regeneration', text: 'Morgen wieder bereit' }
    ];
    const benefits = defaults.map((fallback, index) => ({
      title: benefitContent[index]?.title || fallback.title,
      text: benefitContent[index]?.text || fallback.text
    }));
    const oldAvatars = purchaseProof
      ? [...purchaseProof.querySelectorAll('.tgo-hero-proof__avatars img')]
      : [];
    const avatarOne = oldAvatars[0]?.currentSrc || oldAvatars[0]?.src ||
      'https://cdn.shopify.com/s/files/1/0705/3623/3226/files/Ahmed_Kutucu_f229366b-2fd8-4931-a2e1-3417ab59e8d5.webp?v=1772710240&width=96';
    const avatarTwo = oldAvatars[1]?.currentSrc || oldAvatars[1]?.src ||
      'https://cdn.shopify.com/s/files/1/0705/3623/3226/files/Marcel_Hartel_572608b9-d9e1-4134-aeaa-8828687f82ca.webp?v=1772710533&width=96';
    const proofTitle = purchaseProof?.querySelector('.tgo-hero-proof__copy strong')?.textContent.trim() ||
      'Mehr als 2.000 Mal gekauft';
    const proofRecommendation =
      purchaseProof?.querySelector('.tgo-hero-proof__recommendation')?.textContent.trim() ||
      purchaseProof?.querySelector('.tgo-hero-proof__copy span')?.textContent.trim() ||
      'Von Sportlern empfohlen';
    const oldVideo = existing?.querySelector('.tgo-hero-video');
    const videoLabel = oldVideo?.querySelector('.tgo-hero-video__label')?.textContent.trim() ||
      oldVideo?.textContent.replace(/\s+/g, ' ').trim() ||
      'The Golden One in 30 Sekunden erklärt';
    const videoHref = oldVideo?.tagName === 'A' ? oldVideo.getAttribute('href') : '';
    const block = existing || document.createElement('div');
    block.className = 'tgo-hero-commerce';
    block.dataset.tgoHeroCommerce = '';
    block.dataset.tgoReferenceLayout = '';
    block.innerHTML = `
      <div class="tgo-hero-commerce__grid">
        <div class="tgo-hero-benefits" role="list" aria-label="Kernvorteile">
          ${benefits.map((benefit, index) => `
            <div class="tgo-hero-benefit" role="listitem">
              <span class="tgo-hero-benefit__icon" aria-hidden="true">
                <img src="${tgoAssetUrl(['icon-lightning-bolt.svg', 'icon-checkmark.svg', 'icon-recycle.svg'][index])}" alt="" width="22" height="22">
              </span>
              <span class="tgo-hero-benefit__copy"><strong>${benefit.title}</strong><span>${benefit.text}</span></span>
            </div>`).join('')}
        </div>

        ${videoHref
          ? `<a class="tgo-hero-video" href="${videoHref}" target="_blank" rel="noopener" aria-label="${videoLabel}">`
          : '<span class="tgo-hero-video" aria-disabled="true" title="Video-Link im Theme-Editor hinterlegen">'}
            <img class="tgo-hero-video__image" src="${HERO_VIDEO_IMAGE}" alt="" width="900" height="600" loading="lazy">
            <span class="tgo-hero-video__shade" aria-hidden="true"></span>
            <span class="tgo-hero-video__content">
              <span class="tgo-hero-video__play" aria-hidden="true"><img src="${tgoAssetUrl('icon-play.svg')}" alt="" width="18" height="18"></span>
              <span class="tgo-hero-video__kicker">30 SEKUNDEN</span>
              <strong class="tgo-hero-video__label">${videoLabel.replace(' in 30 Sekunden ', ' ')}</strong>
            </span>
          ${videoHref ? '</a>' : '</span>'}
      </div>`;

    const trust = hero.querySelector('.tgo13-hero-trust');
    const payment = hero.querySelector('.golden-smartrr__payment-wrap, .golden-smartrr__payment-icons');
    const anchor = trust || payment;
    if (anchor) {
      anchor.insertAdjacentElement('afterend', block);
    } else {
      const info = hero.querySelector('.golden-smartrr__info');
      info?.appendChild(block);
    }

    if (showPurchaseProof) {
      const proof = purchaseProof || document.createElement('div');
      proof.className = 'tgo-hero-proof tgo-hero-proof--purchase-flow';
      proof.dataset.tgoPurchaseProof = '';
      proof.setAttribute('aria-label', `${proofTitle}. ${proofRecommendation}`);
      proof.innerHTML = `
        <span class="tgo-hero-proof__avatars" aria-hidden="true">
          <img src="${avatarOne}" alt="" width="48" height="48" loading="lazy">
          <img src="${avatarTwo}" alt="" width="48" height="48" loading="lazy">
        </span>
        <span class="tgo-hero-proof__copy"><strong>${proofTitle}</strong></span>
        <span class="tgo-hero-proof__divider" aria-hidden="true"></span>
        <span class="tgo-hero-proof__recommendation">${proofRecommendation}</span>`;

      const firstPlan = hero.querySelector('.golden-smartrr__benefits-box') ||
        hero.querySelector('.golden-smartrr__options');
      const title = hero.querySelector('.golden-smartrr__title');
      if (firstPlan && proof.nextElementSibling !== firstPlan) {
        firstPlan.parentNode?.insertBefore(proof, firstPlan);
      } else if (!firstPlan && title && title.nextElementSibling !== proof) {
        title.insertAdjacentElement('afterend', proof);
      }
    } else {
      purchaseProof?.remove();
    }
  }

  function updateWhyContent() {
    const why = document.querySelector('.tgo13-why');
    if (!why) return;
    setImage(why.querySelector('.tgo13-why__product img'), WHY_IMAGE, 'The Golden One Produktset');
    const kicker = why.querySelector('.tgo13-kicker');
    if (kicker) kicker.hidden = true;
    const headingIcon = why.querySelector('.tgo13-heading__icon');
    const introIcon = why.querySelector('.tgo13-why__intro-icon');
    if (headingIcon) headingIcon.innerHTML = icons.sparkle;
    if (introIcon) introIcon.innerHTML = icons.routine;
    const introTitle = why.querySelector('.tgo13-why__intro h3');
    if (introTitle) introTitle.textContent = 'Deine tägliche Rundum-Versorgung.';
    const proofItems = why.querySelectorAll('.tgo13-proof-strip > span');
    [icons.check, icons.truck, icons.pause, icons.routine].forEach((svg, index) => {
      const target = proofItems[index];
      const old = target?.querySelector('svg');
      if (old) old.outerHTML = svg;
    });
  }

  function injectTgoPolish() {
    document.getElementById('tgo13-reference-polish')?.remove();
    const style = document.createElement('style');
    style.id = 'tgo13-reference-polish';
    style.textContent = `
      html body .tgo13-why {padding:60px 0 58px!important;background:radial-gradient(circle at 50% 35%,rgba(255,255,255,.98) 0 28%,rgba(255,253,248,.92) 58%,rgba(248,244,235,.96) 100%)!important;overflow:hidden!important}
      html body .tgo13-why .tgo13-shell {width:min(100%,1460px)!important;max-width:1460px!important;margin-inline:auto!important;padding-inline:48px!important}
      html body .tgo13-why .tgo13-heading {max-width:920px!important;margin:0 auto 34px!important;text-align:center!important}
      html body .tgo13-why .tgo13-kicker {display:none!important}
      html body .tgo13-why .tgo13-heading__icon {display:none!important}
      html body .tgo13-why svg {fill:none!important;stroke:currentColor!important;stroke-width:1.65!important;stroke-linecap:round!important;stroke-linejoin:round!important}
      html body .tgo13-why .tgo13-heading__icon svg {width:25px!important;height:25px!important}
      html body .tgo13-why .tgo13-heading h2 {margin:0!important;color:#080808!important;font-size:clamp(42px,3.7vw,56px)!important;line-height:1.02!important;letter-spacing:-.045em!important;white-space:normal!important;text-wrap:balance!important}
      html body .tgo13-why .tgo13-heading>p:last-child {margin:14px auto 0!important;color:#5a5752!important;font-size:17px!important;line-height:1.5!important}
      html body .tgo13-why__layout {display:grid!important;grid-template-columns:330px 330px minmax(0,1fr)!important;column-gap:0!important;align-items:stretch!important}
      html body .tgo13-why__intro {display:flex!important;flex-direction:column!important;min-height:450px!important;padding:38px 32px 34px!important;border:1px solid rgba(217,207,191,.78)!important;border-radius:18px!important;background:rgba(255,255,255,.8)!important;box-shadow:0 12px 32px rgba(58,41,7,.055)!important}
      html body .tgo13-why__intro-icon {color:#c99100!important}
      html body .tgo13-why__intro-icon svg {width:42px!important;height:42px!important}
      html body .tgo13-why__intro h3 {margin:30px 0 28px!important;color:#111!important;font-size:27px!important;line-height:1.18!important;letter-spacing:-.035em!important;max-width:245px!important;hyphens:none!important;word-break:normal!important;overflow-wrap:normal!important}
      html body .tgo13-why__intro>p {margin:0!important;color:#3f3f3f!important;font-size:15px!important;line-height:1.72!important;hyphens:none!important;word-break:normal!important}
      html body .tgo13-mini-proof {margin-top:auto!important;gap:11px!important;padding-top:30px!important;color:#c99100!important}
      html body .tgo13-mini-proof svg {width:22px!important;height:22px!important}
      html body .tgo13-mini-proof span {color:#303030!important;font-size:14px!important;font-weight:700!important;white-space:nowrap!important}
      html body .tgo13-why__product {display:grid!important;place-items:center!important;min-height:450px!important;overflow:visible!important;border:0!important;background:transparent!important}
      html body .tgo13-why__halo {display:none!important}
      html body .tgo13-why__product img {display:block!important;width:116%!important;max-width:390px!important;height:450px!important;margin:0 0 -7px -8px!important;object-fit:contain!important;object-position:center bottom!important;mix-blend-mode:normal!important;filter:drop-shadow(0 20px 22px rgba(48,35,8,.11))!important;transform:none!important}
      html body .tgo13-why__benefit-area {display:flex!important;min-width:0!important;flex-direction:column!important;align-self:center!important;padding-left:26px!important}
      html body .tgo13-why__benefit-label {display:flex!important;align-items:center!important;gap:20px!important;margin:0 0 20px!important}
      html body .tgo13-why__benefit-label span {height:1px!important;flex:1!important;background:rgba(201,145,0,.52)!important}
      html body .tgo13-why__benefit-label strong {color:#5a5752!important;font-size:13px!important;font-weight:600!important;letter-spacing:.01em!important;white-space:nowrap!important}
      html body .tgo13-why__benefits {display:grid!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:14px!important;flex:none!important}
      html body .tgo13-benefit-card {display:flex!important;min-width:0!important;min-height:224px!important;flex-direction:column!important;align-items:flex-start!important;justify-content:flex-start!important;padding:24px 21px!important;border:1px solid rgba(217,207,191,.78)!important;border-radius:16px!important;background:rgba(255,255,255,.82)!important;box-shadow:none!important;text-align:left!important}
      html body .tgo13-benefit-card__icon {display:grid!important;place-items:center!important;width:46px!important;height:46px!important;border:0!important;border-radius:0!important;color:#c99100!important}
      html body .tgo13-benefit-card__icon svg {width:38px!important;height:38px!important}
      html body .tgo13-benefit-card h3 {width:100%!important;margin:18px 0 10px!important;color:#111!important;font-size:18px!important;font-weight:720!important;line-height:1.18!important;white-space:normal!important;hyphens:none!important;word-break:normal!important;overflow-wrap:normal!important}
      html body .tgo13-benefit-card p {width:100%!important;max-width:none!important;margin:0!important;color:#55514b!important;font-size:14px!important;line-height:1.52!important;hyphens:none!important;word-break:normal!important;overflow-wrap:normal!important}
      html body .tgo13-proof-strip {grid-template-columns:repeat(4,minmax(0,1fr))!important;margin-top:40px!important;border:1px solid rgba(217,207,191,.78)!important;border-radius:16px!important;background:rgba(255,255,255,.72)!important;box-shadow:0 12px 30px rgba(49,35,7,.04)!important}
      html body .tgo13-proof-strip span {min-height:86px!important;gap:16px!important;color:#c99100!important}
      html body .tgo13-proof-strip svg {width:30px!important;height:30px!important}
      html body .tgo13-proof-strip b {color:#303030!important;font-size:14px!important;font-weight:600!important;white-space:nowrap!important}

      @media screen and (max-width:1250px){
        html body .tgo13-why .tgo13-shell{padding-inline:30px!important}
        html body .tgo13-why__layout{grid-template-columns:300px 300px minmax(0,1fr)!important}
        html body .tgo13-why__product img{max-width:340px!important}
        html body .tgo13-why__benefit-area{padding-left:20px!important}
        html body .tgo13-why__benefits{grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:12px!important}
        html body .tgo13-benefit-card{min-width:0!important;padding-inline:18px!important}
        html body .tgo13-benefit-card h3{font-size:17px!important}
      }
      @media screen and (max-width:1020px){
        html body .tgo13-why .tgo13-heading h2{white-space:normal!important}
        html body .tgo13-why__layout{grid-template-columns:1fr 1fr!important;gap:22px!important}
        html body .tgo13-why__benefit-area{grid-column:1/-1!important;padding-left:0!important}
        html body .tgo13-why__benefits{grid-template-columns:repeat(3,1fr)!important}
        html body .tgo13-benefit-card h3{font-size:17px!important}
      }
      @media screen and (max-width:749px){
        html body .golden-smartrr.tgo13-hero .tgo13-hero-proof-actions{grid-template-columns:1fr!important;gap:8px!important}
        html body .golden-smartrr.tgo13-hero .tgo13-customer-proof,
        html body .golden-smartrr.tgo13-hero .tgo13-video-button{min-height:46px!important}
        html body .golden-smartrr.tgo13-hero .tgo13-delivery-note{justify-content:flex-start!important;margin-left:4px!important}
        html body .tgo13-why{padding:60px 0 42px!important}
        html body .tgo13-why .tgo13-shell{padding-inline:18px!important}
        html body .tgo13-why .tgo13-heading h2{font-size:clamp(34px,10vw,40px)!important;white-space:normal!important}
        html body .tgo13-why .tgo13-heading>p:last-child{font-size:15px!important}
        html body .tgo13-why__layout{grid-template-columns:1fr!important;gap:22px!important}
        html body .tgo13-why__intro{min-height:0!important}
        html body .tgo13-why__intro h3{max-width:none!important}
        html body .tgo13-why__product{min-height:330px!important}
        html body .tgo13-why__product img{width:100%!important;max-width:350px!important;height:330px!important;margin:0!important}
        html body .tgo13-why__benefit-label{margin-top:10px!important;gap:12px!important}
        html body .tgo13-why__benefit-label strong{font-size:13px!important}
        html body .tgo13-why__benefits{grid-template-columns:1fr!important}
        html body .tgo13-benefit-card{min-height:0!important;padding:22px!important}
        html body .tgo13-benefit-card h3{white-space:normal!important}
        html body .tgo13-proof-strip{grid-template-columns:1fr 1fr!important}
        html body .tgo13-proof-strip span:nth-child(3){border-left:0!important;border-top:1px solid rgba(217,207,191,.78)!important}
        html body .tgo13-proof-strip span:nth-child(4){border-top:1px solid rgba(217,207,191,.78)!important}
        html body .tgo13-proof-strip b{white-space:normal!important}
      }
    `;
    document.head.appendChild(style);
  }

  function initialise(scope = document) {
    injectTgoPolish();
    orderEditorialSections();
    updateWhyContent();
    observePlanVisuals();
    mountHeroCommerceFallback();
    scope.querySelectorAll(SELECTOR).forEach(initialiseCarousel);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
